var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResolved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1734_42099)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1734_42099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.43164C7.5368 3.43164 3.5 7.46844 3.5 12.4316C3.5 17.3948 7.5368 21.4316 12.5 21.4316C17.4632 21.4316 21.5 17.3948 21.5 12.4316C21.5 7.46844 17.4632 3.43164 12.5 3.43164ZM12.5 20.2316C8.1992 20.2316 4.7 16.7324 4.7 12.4316C4.7 8.13084 8.1992 4.63164 12.5 4.63164C16.8008 4.63164 20.3 8.13084 20.3 12.4316C20.3 16.7324 16.8008 20.2316 12.5 20.2316Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3064 14.055L8.13356 10.8822L7.28516 11.7306L11.3124 15.7578L17.7276 9.25256L16.8732 8.41016L11.3064 14.055Z",
    fill: "#545B5B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1734_42099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.431641)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1734_42099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3.5 3.43164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolved);
export default __webpack_public_path__ + "static/media/resolved.7686d0b83ed1aa163bba19392bf2a3b9.svg";
export { ForwardRef as ReactComponent };